<template>
  <div class="cm-fr-stats-page">
    <!-- select options -->
    <div style="width: 415px">
      <v-select   
        v-model="filterDeviceModel" 
        :items="filterOptions"
        item-text="label"
        item-value="value"
        label="Device Model"
        :loading="loading"
        :disabled="loading"
      ></v-select>
    </div>

    <!-- firmware charts -->
    <div style="display: flex; margin-top: 10px">
      <!-- firmware version chart -->
      <div style="padding: 5px 10px; border: 1px solid #eee; height: 350px; width: 450px; margin-right: 20px">
        <FirmwareVersionBarChart :info="versionByModel" />
      </div>

      <!-- percentage distribution chart -->
      <div style="padding: 5px 10px; border: 1px solid #eee; height: 350px; width: 400px">
        <FirmwareVersionPieChart :info="versionByModel" />
      </div>
    </div>

    <!-- summary chart-->
    <div style=" margin-top: 20px; width: 300px; height: 200px;">
      <FirmwareVersionTable :info="versionByModel" />
    </div>
  </div>
</template>

<script>
import FirmwareVersionBarChart from './charts/FirmwareVersionBarChart.vue'
import FirmwareVersionPieChart from './charts/FirmwareVersionPieChart.vue'
import FirmwareVersionTable from './charts/FirmwareVersionTable.vue'

// import { CreateFirmwarePackage, uploadFirmwarePackage, DeleteFirmwarePackage, , updateFirmwareRollout, createFirmwareRollout,  } from "@/services/API.js"

import { 
  getDeviceModels,
  getFirmwareRolloutStats
} from '@/services/API.js'

import { Logger } from "aws-amplify"
const logger = new Logger("Firmware rollout stats")

export default {
  components: {
    FirmwareVersionBarChart,
    FirmwareVersionPieChart,
    FirmwareVersionTable
  },

  data () {
    return {
      filterDeviceModel: 'CAMERAMATICS_JH8_NT-HD-4G',
      versionByModel: [],
      deviceModels: []
    }
  },

  watch: {
    filterDeviceModel(val) {
      if(val != 'all') {
        this.GetRollOutInfo(val)
      }
    }
  },

  computed: {
    filterOptions() {
      return this.deviceModels.filter(i => i.manufacturer == 'Cameramatics').map(i => {
        return {
          label: i.model,
          value: i.model
        }
      })
    }
  },

  methods: {
    formatVersion(version) {
      const formatVersionSubStr = (val) => {
        logger.info('val', val)
        let components = val.split('.')
        let versionObj = {
          major: '',
          minor: '',
          patch: ''
        }

        components.forEach((sub, index) => {
          if(index == 0) {
            let integer = parseInt(sub)
            
            versionObj.major = integer < 10 ? `0${integer}` : `${integer}`
          }
          if(index == 1) {
            let integer = parseInt(sub)
            
            versionObj.minor = integer < 10 ? `0${integer}` : `${integer}`
          }
          if(index == 2) {
            let integer = parseInt(sub)
            
            versionObj.patch = integer < 10 ? `0${integer}` : `${integer}`
          }
        })
        return `${versionObj.major}.${versionObj.minor}.${versionObj.patch}`
      }

      return formatVersionSubStr(version)
    },

    async getDeviceModels() {
      const models = await getDeviceModels()

      if(models && Object.hasOwn(models, 'device_models')) {
        this.deviceModels = models.device_models
      }
    },

    GetRollOutInfo (model) {
      this.loading = true
      getFirmwareRolloutStats(model).then(res => {
        const compareVersionsDesc = (a, b) => {
          const splitA = a.fw_version.split('.').map(Number);
          const splitB = b.fw_version.split('.').map(Number);

          for (let i = 0; i < 3; i++) {
            if (splitA[i] > splitB[i]) return -1;
            if (splitA[i] < splitB[i]) return 1;
          }
          return 0;
        }
        
        if(res.stats) {
          this.versionByModel = res.stats.sort(compareVersionsDesc)
        }
        this.loading = false
      }).catch (err => {
        logger.debug("err getting rollout info", err)
        this.loading = false
      })
    }
  },

  mounted () {
    this.getDeviceModels().then(() => {
      this.GetRollOutInfo(this.filterDeviceModel)
    })
  }
}
</script>

<style lang="scss" scoped>
.cm-fr-stats-page {
  padding: 10px 15px;
}
</style>